import { set } from 'js-cookie';
import React, { FunctionComponent } from 'react';

import ResponsiveHeader from '@gojob/ui-bits/ResponsiveHeader';
import Divider from '@gojob/ui-bits/ResponsiveHeader/Divider';
import HeaderLink from '@gojob/ui-bits/ResponsiveHeader/Link';
import TranslationProvider from '@gojob/ui-bits/ResponsiveHeader/TranslationProvider';

import Link from '../Link';

import { UniverseFragmentResponse } from '../../fragments/universe';
import { UniverseHeaderItem } from '../../fragments/universe-header';
import useTranslation from '../../translations/useTranslation';

export type HeaderProps = {
  universe: UniverseFragmentResponse;
};

const renderItem = (item?: UniverseHeaderItem, index?: number) => {
  const language = item?.internalRef?.i18n_lang ?? 'fr_FR';

  switch (item?.__typename) {
    case 'SanityHeaderLink':
      return (
        <HeaderLink
          key={index}
          as={Link}
          newFeature={item.featured}
          to={item.internalRef?.slug?.current}
          href={item.href}
          icon={item.icon?.type}
          onClick={() => {
            const country = language.split('_')[1];
            set('nf_country', country, { expires: 365 });
          }}
        >
          {item?.children}
        </HeaderLink>
      );
    case 'SanityDivider':
      return <Divider key={index} />;
    default:
      return null;
  }
};

const Header: FunctionComponent<HeaderProps> = (props) => {
  const { universe } = props;
  const t = useTranslation();

  if (!universe) {
    return null;
  }

  const { items, logo, sibling_universe } = universe;

  return (
    <TranslationProvider translationFunction={t}>
      <ResponsiveHeader
        /** Sadly we need to cast this to any as Link does not explicitely state this key in it's props */
        LogoProps={{ as: Link, to: logo?.internalRef?.slug?.current, 'aria-label': logo?.ariaLabel } as any}
      >
        {items?.map(renderItem)}

        {universe?.sibling_universe?.children ? (
          <HeaderLink
            as={Link}
            variant="primary"
            to={sibling_universe?.internalRef?.root_page?.slug?.current}
            icon={sibling_universe?.icon?.type}
          >
            {sibling_universe?.children}
          </HeaderLink>
        ) : null}
      </ResponsiveHeader>
    </TranslationProvider>
  );
};

export default Header;
